import Cohort from "./Cohort";
import General from "./General";

const pages = { Cohort, General };

export default pages;
